import { render, staticRenderFns } from "./MatifChart.vue?vue&type=template&id=d9e638fc"
import script from "./MatifChart.vue?vue&type=script&lang=js"
export * from "./MatifChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports